export default () => {

  const $PRODUCT_IDS = window.$App.globals.products.mapProductIds;
  const $PARAM_IDS = window.$App.globals.products.parameterIds;

  const $ALLOWED_MAP_PRODUCTS = window.$App.globals.products.allowedMapProducts
    .map((product) => $PRODUCT_IDS[product])
    .filter((product) => product);

  const $DEFAULT_MAP_PRODUCT_SETTINGS = window.$App.globals.products.defaultMapProductSettings;

  return {
    $PRODUCT_IDS,
    $PARAM_IDS,
    $ALLOWED_MAP_PRODUCTS,
    $DEFAULT_MAP_PRODUCT_SETTINGS
  }
}